import React, { useState } from 'react';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import { updateGenresFromFile } from '../services/api';

function UpdateGenreModal({ show, onHide, onUpdateSuccess }) {
  const [file, setFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [uploadResult, setUploadResult] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
    setError(null);
    setSuccessMessage(null);
    setUploadResult(null);
  };

  const handleUpload = async () => {
    if (!file) {
      setError("Per favore, seleziona un file.");
      return;
    }

    setIsUploading(true);
    setError(null);
    setSuccessMessage(null);

    try {
      const response = await updateGenresFromFile(file);
      setSuccessMessage(response.data.message || "Aggiornamento completato con successo.");
      setUploadResult(response.data);
      if (onUpdateSuccess) {
        onUpdateSuccess();
      }
    } catch (err) {
      const errorMessage = err.response?.data?.detail || "Si è verificato un errore durante l'aggiornamento.";
      setError(errorMessage);
      console.error(err);
    } finally {
      setIsUploading(false);
    }
  };

  const handleClose = () => {
    setFile(null);
    setError(null);
    setSuccessMessage(null);
    setUploadResult(null);
    setIsUploading(false);
    onHide();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Aggiorna Generi da File</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Seleziona un file Excel (.xlsx, .xls) o CSV con due colonne: <strong>sku</strong> e <strong>genere</strong>.
          Il sistema aggiornerà il genere per ogni film corrispondente allo SKU trovato nel database.
        </p>
        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label>File di aggiornamento</Form.Label>
          <Form.Control type="file" onChange={handleFileChange} accept=".xlsx,.xls,.csv" />
        </Form.Group>
        
        {isUploading && <div className="text-center"><Spinner animation="border" /> <p>Aggiornamento in corso...</p></div>}
        
        {error && <Alert variant="danger">{error}</Alert>}

        {successMessage && <Alert variant="success">{successMessage}</Alert>}

        {uploadResult && uploadResult.not_found_skus && uploadResult.not_found_skus.length > 0 && (
          <Alert variant="warning">
            <h6>SKU non trovati</h6>
            <p>I seguenti SKU nel file non sono stati trovati nel database:</p>
            <ul style={{ maxHeight: '150px', overflowY: 'auto' }}>
              {uploadResult.not_found_skus.map(sku => <li key={sku}>{sku}</li>)}
            </ul>
          </Alert>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Chiudi
        </Button>
        <Button variant="primary" onClick={handleUpload} disabled={!file || isUploading}>
          {isUploading ? 'In corso...' : 'Avvia Aggiornamento'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default UpdateGenreModal;
